import { Pipe, PipeTransform } from '@angular/core';

/**
 * colon pipe
 *
 * Usage in the template file:
 * {{ 'my.key' | translate | colon }}
 *
 */
@Pipe({
    name: 'colon',
    standalone: false
})
export class ColonPipe implements PipeTransform {
    /**
     *
     * @param string The string to append
     *
     * @returns appended string with colon added
     */
    transform(key: string): string {
        return `${key}:`;
    }
}
